import actions from './actions';

const {
  PRODUCT_ADDONS_BEGIN,
  PRODUCT_ADDONS_ERR,
  PRODUCT_ADDONS_SUCCESS,

  SINGLE_PRODUCT_ADDON_BEGIN,
  SINGLE_PRODUCT_ADDON_ERR,
  SINGLE_PRODUCT_ADDON_SUCCESS,

  DISABLE_ADDON_BEGIN,
  DISABLE_ADDON_ERR,
  DISABLE_ADDON_SUCCESS,

  EDIT_ADDON_BEGIN,
  EDIT_ADDON_ERR,
  EDIT_ADDON_SUCCESS,

  ADD_ADDON_BEGIN,
  ADD_ADDON_ERR,
  ADD_ADDON_SUCCESS,
} = actions;

const initialStateSingleAddon = {
  data: {},
  loading: false,
  error: null,
  isSubmitting: false,
};

const initialStateAllAddons = {
  data: [],
  loading: false,
  error: null,
  disable: {
    /**
     * id of addons that are loading
     *  {
     *    [id]: loading ? true : false
     *  }
     */
    loading: {},
  },
};

const addonsReducer = (state = initialStateAllAddons, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PRODUCT_ADDONS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case PRODUCT_ADDONS_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case PRODUCT_ADDONS_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DISABLE_ADDON_BEGIN:
      return {
        ...state,
        disable: {
          loading: {
            ...state.disable.loading,
            [action.id]: true,
          },
        },
      };
    case DISABLE_ADDON_ERR:
      return {
        ...state,
        disable: {
          loading: {
            ...state.disable.loading,
            [action.id]: false,
          },
        },
      };
    case DISABLE_ADDON_SUCCESS:
      return {
        ...state,
        disable: {
          loading: {
            ...state.disable.loading,
            [action.id]: false,
          },
        },
      };
    default:
      return state;
  }
};

const singleAddonReducer = (state = initialStateSingleAddon, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SINGLE_PRODUCT_ADDON_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case SINGLE_PRODUCT_ADDON_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case SINGLE_PRODUCT_ADDON_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case EDIT_ADDON_BEGIN:
      return {
        ...state,
        isSubmitting: true,
      };
    case EDIT_ADDON_ERR:
      return {
        ...state,
        isSubmitting: false,
      };
    case EDIT_ADDON_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case ADD_ADDON_BEGIN:
      return {
        ...state,
        isSubmitting: true,
      };
    case ADD_ADDON_ERR:
      return {
        ...state,
        isSubmitting: false,
      };
    case ADD_ADDON_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    default:
      return state;
  }
};

export { addonsReducer, singleAddonReducer };
